<template>
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.8403 1.40002C14.8403 0.84774 14.3926 0.400024 13.8403 0.400024C13.288 0.400024 12.8403 0.84774 12.8403 1.40002V2.32007H7.1604V1.40002C7.1604 0.84774 6.71269 0.400024 6.1604 0.400024C5.60812 0.400024 5.1604 0.84774 5.1604 1.40002V2.32007H3.28035C1.66768 2.32007 0.360352 3.6274 0.360352 5.24007V9.08008V18.6801C0.360352 20.2927 1.66768 21.6001 3.28035 21.6001H16.7204C18.333 21.6001 19.6404 20.2927 19.6404 18.6801V9.08008V5.24007C19.6404 3.6274 18.333 2.32007 16.7204 2.32007H14.8403V1.40002ZM17.6404 8.08008V5.24007C17.6404 4.73197 17.2285 4.32007 16.7204 4.32007H14.8403V5.24002C14.8403 5.79231 14.3926 6.24002 13.8403 6.24002C13.288 6.24002 12.8403 5.79231 12.8403 5.24002V4.32007H7.1604V5.24002C7.1604 5.79231 6.71269 6.24002 6.1604 6.24002C5.60812 6.24002 5.1604 5.79231 5.1604 5.24002V4.32007H3.28035C2.77225 4.32007 2.36035 4.73197 2.36035 5.24007V8.08008H17.6404ZM2.36035 10.0801H17.6404V18.6801C17.6404 19.1882 17.2285 19.6001 16.7204 19.6001H3.28035C2.77225 19.6001 2.36035 19.1882 2.36035 18.6801V10.0801Z"
      fill="black"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
